import Route from '@ember/routing/route';

export default class HotelSettingsMyotbOtherSystemEligibilityRoute extends Route {}
